import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7c59e7c8"
var script = {}
import style0 from "@/assets/scss/main.scss?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7c59e7c8', component.options)
    } else {
      api.reload('7c59e7c8', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=7c59e7c8", function () {
      api.rerender('7c59e7c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/App.vue"
export default component.exports